module.exports = __webpack_public_path__ + "img/lliiibbre.272e060c.jpg";